export default __webpack_public_path__ + "static/media/projectActive.324fd09c.svg";